(() => {
  'use strict';

  const STORAGE_KEY = 'ns:wishlist:v1';
  const MAX_ITEMS = 50;
  const HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/;

  const clean = (items) => {
    if (!Array.isArray(items)) return [];
    return [...new Set(items.filter((item) => typeof item === 'string' && HANDLE_PATTERN.test(item)))].slice(0, MAX_ITEMS);
  };

  const read = () => {
    try {
      return clean(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
    } catch (_error) {
      return [];
    }
  };

  const write = (items) => {
    const next = clean(items);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (_error) {
      return read();
    }
    return next;
  };

  const updateInterface = () => {
    const items = read();
    const saved = new Set(items);

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = saved.has(button.dataset.productHandle || '');
      button.setAttribute('aria-pressed', String(active));
      button.classList.toggle('is-active', active);
      const label = active ? button.dataset.labelRemove : button.dataset.labelAdd;
      if (label) button.setAttribute('aria-label', label);
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
      counter.textContent = items.length > 99 ? '99+' : String(items.length);
      counter.hidden = items.length === 0;
    });
  };

  const announceChange = (items) => {
    updateInterface();
    window.dispatchEvent(new CustomEvent('ns:wishlist:change', { detail: { items } }));
  };

  const toggle = (handle) => {
    if (!HANDLE_PATTERN.test(handle || '')) return read();
    const items = read();
    const index = items.indexOf(handle);
    if (index >= 0) items.splice(index, 1);
    else items.unshift(handle);
    const next = write(items);
    announceChange(next);
    return next;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(button.dataset.productHandle || '');
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) announceChange(read());
  });

  let updateQueued = false;
  const observer = new MutationObserver((mutations) => {
    const needsUpdate = mutations.some((mutation) => [...mutation.addedNodes].some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches('[data-wishlist-toggle], [data-wishlist-count]') || Boolean(node.querySelector('[data-wishlist-toggle], [data-wishlist-count]'));
    }));
    if (!needsUpdate || updateQueued) return;
    updateQueued = true;
    requestAnimationFrame(() => {
      updateQueued = false;
      updateInterface();
    });
  });

  window.NSWishlist = Object.freeze({
    get: read,
    has: (handle) => read().includes(handle),
    toggle,
    remove: (handle) => {
      const next = write(read().filter((item) => item !== handle));
      announceChange(next);
      return next;
    },
    sync: updateInterface,
  });

  updateInterface();
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.dispatchEvent(new CustomEvent('ns:wishlist:ready'));
})();
